import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Target } from "lucide-react";
import client from "@/lib/api";

export default function SaveGoalButton({ scenario, isSaved, onSaved }) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const save = async () => {
    setSaving(true);
    setError("");
    try {
      const { data } = await client.put("/me/goal", scenario);
      onSaved(data.goal);
    } catch {
      setError("Couldn't save your goal. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mt-4 flex flex-wrap items-center gap-3">
      <button data-testid="save-goal-btn" onClick={save} disabled={saving || isSaved}
        className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-60"
        style={{ backgroundColor: "var(--tenant-primary)" }}>
        <Target size={16} /> {saving ? "Saving…" : isSaved ? "Saved as my goal" : "Save as my goal"}
      </button>
      {isSaved && <Link to="/roadmap" data-testid="goal-saved-link" className="tenant-text text-sm font-medium hover:underline">See it on your Action Roadmap →</Link>}
      {error && <p className="w-full text-xs text-[#D96C4A]" data-testid="save-goal-error">{error}</p>}
    </div>
  );
}
